import { render, staticRenderFns } from "./CustomCursor.vue?vue&type=template&id=6125a96a&scoped=true"
import script from "./CustomCursor.vue?vue&type=script&lang=js"
export * from "./CustomCursor.vue?vue&type=script&lang=js"
import style0 from "./CustomCursor.vue?vue&type=style&index=0&id=6125a96a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6125a96a",
  null
  
)

export default component.exports